// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2-663","detailsBorder":"styles_detailsBorder__dWwyD"};